import './style.scss';
import { ResultBody, ResultHeader } from 'views/mutual/result';
import { Caption } from 'views/mutual/caption';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import { ContractDetailInfo } from 'views/utils/graphql/graphql';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { useNavigate } from 'react-router-dom';
import { ProductType, ProductTypeMap } from 'constants/productType';
import { DateFormatType, formatDate, formatPrice } from 'views/utils/converter';

type DomesticRealEstateContractConfirmProps = {
  contractInfo: ContractDetailInfo;
};

export const DomesticRealEstateContractComplete = ({
  contractInfo,
}: DomesticRealEstateContractConfirmProps) => {
  useCustomLocationName('契約締結完了');
  const navigate = useNavigate();

  return (
    <>
      <div className="domesticRealEstate-contractComplete">
        <div className="domesticRealEstate-contractComplete_descriptionWrapper">
          <Description
            label="契約締結をお申込みいただいた以下の案件について、"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
          />
          <Description
            label="お客様（買主）と、株式会社FPG（売主）との間で、ご契約が成立しました。"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
          />
          <Description
            label="支払日までに売買代金をお支払いいただきますようお願い申し上げます。"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
          />
          <br />
          <Description
            label={`お支払いに関する情報は振込依頼書にも記載しております。`}
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
          />
          <Description
            label={`振込依頼書は、交付書面 > ${
              ProductTypeMap[contractInfo.ProductType as ProductType]?.name
            } > 契約関連書面 からもご確認いただけます。`}
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
          />
        </div>
        <Caption label="お申込内容" />
        <div className="domesticRealEstate-contractComplete_wrapper">
          <DomesticRealEstateContractConfirmBody contractInfo={contractInfo} />
        </div>
        <Caption label="振込先情報" />
        <div className="domesticRealEstate-contractComplete_wrapper">
          <ResultHeader label="振込銀行" />
          <ResultBody label={contractInfo.PayeeBankName} />
          <ResultHeader label="支店名" />
          <ResultBody label={contractInfo.PayeeBankBranchName} />
          <ResultHeader label="口座" />
          <ResultBody label={contractInfo.PayeeBankAccountTypeName} />
          <ResultHeader label="口座番号" />
          <ResultBody label={contractInfo.PayeeBankAccount} />
          <ResultHeader label="口座名義" />
          <ResultBody
            label={`${contractInfo.PayeeBankAccountHolderName}（${contractInfo.PayeeBankAccountHolderNameKana}）`}
          />
        </div>
        <div className="domesticRealEstate-contractComplete_wrapper">
          <Description
            label={`契約時交付書面を交付しました。`}
            labelColor={labelColor.red}
            labelSize={labelSize.large}
          />
          <Description
            label={`以下のボタンから交付書面にアクセスし、契約締結時交付書面を必ずご確認ください。`}
            labelColor={labelColor.red}
            labelSize={labelSize.large}
          />
        </div>
        <div className="domesticRealEstate-contractComplete_wrapper">
          <Button
            label="交付書面"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(`${PagePath.IssuanceDocument}?id=0205${contractInfo.Symbol}`)}
          />        
          <Button
            label="出資案件一覧へ"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.Position)}
          />
          <Button
            label="HOMEに戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.Home)}
          />
        </div>
      </div>
    </>
  );
};

//Confirmに切り離して定義する
export const DomesticRealEstateContractConfirmBody = ({ contractInfo }: { contractInfo: ContractDetailInfo }) => {
  return (
    <>
          <ResultHeader label="案件名称" />
          <ResultBody label={contractInfo.SymbolName} />
          <ResultHeader label="申込金額" />
          <ResultBody label={formatPrice(contractInfo.ApplicationAmount) + '円'} />
          <ResultHeader label="振込期日" />
          <ResultBody label={formatDate(new Date(contractInfo.PaymentDate), DateFormatType.Japanese_yyyyMd)} />
          <ResultHeader label="諸費用　※確定日付取得費用" />
          <ResultBody label={formatPrice(contractInfo.ExpensesTotal) + '円'} />
          <ResultHeader label="購入代金総額" />
          <ResultBody label={formatPrice(contractInfo.TotalTransferFee) + '円'} />
    </>
  );
};